import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { AdminSetupAddFineTypeComponent } from "./admin-setup-add-fine-type/admin-setup-add-fine-type.component";
import { AdminSetupEditFineTypeComponent } from "./admin-setup-edit-fine-type/admin-setup-edit-fine-type.component";
import { DataService_FineTypeSetup } from "./shared/data.service";

@Component({
	selector: "app-fine-type-setup",
	templateUrl: "./fine-type-setup.component.html",
	styleUrls: ["./fine-type-setup.component.css"],
})
export class FineTypeSetupComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private FineTypeSetupService: DataService_FineTypeSetup,
		private dialogService: DialogService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadSchoolist();
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;

	SchoolID: any;
	lstSchool: any = [];

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedFineType: any;
	lstFineType: any = [];

	//Filter lists
	lstDefinedByDesc: any = [];
	lstUsedByDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "AccountDebitTypeDesc", header: "Description" },
		{ field: "AccountDebitTypeCD", header: "Code" },
		{ field: "AccountDebitDefaultAmount", header: "Fine Amount" },
		// { field: 'DefinedByDesc', header: 'Defined By' },
		// { field: 'UsedByDesc', header: 'Used By' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.SchoolID = this.lstSchool[0].SchoolID;

				this.loadFineType();
			},
			(error) => {}
		);
	}

	loadFineType() {
		this.loading = true;

		var result = this.FineTypeSetupService.LoadFineType(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstFineType = response;

				for (var i = 0; i < this.lstFineType.length; i++) {
					var next = this.lstFineType[i];

					next.UsedByDesc = next.SchoolID > 0 ? "This School Only" : "District";
				}

				//Load Data Filter Lists
				this.lstDefinedByDesc = Array.from(new Set(this.lstFineType.map((item: any) => item.DefinedByDesc))).sort();
				this.lstUsedByDesc = Array.from(new Set(this.lstFineType.map((item: any) => item.UsedByDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadFineType();
	}

	//Custom Button Methods
	onAddFineType() {
		this.errorMessage = "";

		var ref = this.dialogService.open(AdminSetupAddFineTypeComponent, {
			header: "Add Fine Type",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SchoolID: this.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadFineType();
			}
		});
	}

	onEditFineType() {
		this.errorMessage = "";

		if (this.SelectedFineType == undefined) {
			this.errorMessage = "Select a fine type to edit";
			return;
		}

		if (this.SelectedFineType.DefinedByDesc == "System" || this.SelectedFineType.DefinedByDesc == "Import") {
			this.errorMessage = "Cannot edit system-defined or import-defined fine types";
			return;
		}

		if (this.SelectedFineType.DefinedByDesc == "District User" && this.user.UserLevelID == 3) {
			this.errorMessage = "School users cannot edit district-level fine types";
			return;
		}

		var ref = this.dialogService.open(AdminSetupEditFineTypeComponent, {
			header: "Edit Fine Type",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SchoolID: this.SchoolID,
				SelectedFineType: this.SelectedFineType,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadFineType();
			}
		});
	}

	onDeleteFineType() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedFineType == undefined) {
			this.errorMessage = "Select a fine type to delete";
			return;
		}

		if (this.SelectedFineType.DefinedByDesc == "System" || this.SelectedFineType.DefinedByDesc == "Import") {
			this.errorMessage = "Cannot delete system-defined or import-defined fine types";
			return;
		}

		if (this.SelectedFineType.DefinedByDesc == "District User" && this.user.UserLevelID == 3) {
			this.errorMessage = "School users cannot delete district-level fine types";
			return;
		}

		//Call SP
		var result = this.FineTypeSetupService.FineTypeDelete(this.SelectedFineType.AccountDebitTypeID);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadFineType();
					this.onRowUnselect(null);
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the Fine Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onSchoolChange(val) {
		this.SchoolID = val;

		this.loadFineType();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedFineType = val.data;
	}
	onRowUnselect(val) {
		this.SelectedFineType = null;
	}
	onRowDblClick(FineType) {
		this.SelectedFineType = FineType;
		this.onEditFineType();
	}
	////////////////////////////////////////////
}
